/*toggle knop aan of uit*/
$(document).ready(function () {
    $('#menu-btn').change(function () {//id menu-btn als die de waarde "checked" mee krijgt
        if ($('#menu-btn').is(":checked")) {
            $('body').css('overflow', 'hidden');//dan zorg dat je niet kan scrollen
            $('#page').css('overflow', 'hidden');//dan zorg dat je niet kan scrollen
        } else {
            $('body').css('overflow', 'auto');//default
            $('#page').css('overflow', 'auto');//default
        }
    });
//https://stackoverflow.com/questions/7717527/smooth-scrolling-when-clicking-an-anchor-link
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
    });
    $("body").fitVids();//scales videos with id
//dit is het ik click hier op dus doe dat scriptje
    if ("ontouchstart" in document.documentElement) { //start als ik dit aanraakt
        $('.nav').on('click', 'li.main:not(.open) > a', (function (e) { //van de nav
            e.preventDefault();//zorg dat ik niet direct open ga
            $('.nav li.main').removeClass('open');//ga open
            $(this).parent().addClass('open');//laat sub-menu zien
        }));
    }
    $(function () {
        // bind change event to select
        $('#dynamic_select').on('change', function () {
            var url = $(this).val(); // get selected value
            if (url) { // require a URL
                window.location = url; // redirect
            }
            return false;
        });
    });


    $('.work-slider .slider').slick({ //.slick
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: $('.slider-buttons'),
        arrows: false,
        centerMode: true,
        centerPadding: '18.75%',
        focusOnSelect:true
    });
});

    /*
    $('.slider').slick({ //.slick
        // normal options...
        //infinite: true,
        autoplay: false,
        animation: "slide",
        dots: true,
        arrows: false,
        // the magic
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                infinite: false
            }
        }, {

            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                dots: false
            }

        }]
    });
    lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true,

    });

    $('.ae-slider').slick({ //.slick
        // normal options...
        //infinite: true,
        autoplay: false,
        animation: "slide",
        dots: false,
        rows: 1,
        centerMode: false,
        arrows: true,
        prevArrow: $('.ae_prev'),//dit verwijst naar de overuler voor de default button
        nextArrow: $('.ae_next'),
        // the magic
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    centerPadding: "80px"

                }
            }]


    });
})
;
*/
/*-----------------------------------------------------------------*/








